import styled from 'styled-components';

export const DotsWrapperDiv = styled.div`
  color: ${(p) => p.theme.c.bg['feature-5']};
  position: relative;
`;
